<template>
    <Card title="Account Health">
      <div class="text-gray-600 text-sm mb-4">An overview of your platform health</div>
      <div class="space-y-2">
        <div class="flex items-center gap-2">
          <span class="text-green-600 text-xl">♥</span>
          <span class="font-semibold text-green-600">Healthy</span>
          <span class="text-gray-500 text-xs ml-2">AWS-style overview</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-green-700 font-bold">OK</span>
          <span class="font-semibold">API Responsiveness</span>
          <span class="text-gray-500 text-xs ml-2">All endpoints are responsive</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-green-600 font-bold">Healthy</span>
          <span class="font-semibold">Backup Status</span>
          <span class="text-gray-500 text-xs ml-2">Backups are running on schedule</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-blue-600 font-bold">Normal</span>
          <span class="font-semibold">Service Quotas</span>
          <span class="text-gray-500 text-xs ml-2">No quota limits exceeded</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-yellow-500 font-bold">Low</span>
          <span class="font-semibold">Error Rate</span>
          <span class="text-gray-500 text-xs ml-2">Minimal errors detected</span>
        </div>
      </div>
    </Card>
  </template>

<script>
import Card from '../../Card.vue'
export default {
  name: 'HealthCard',
  components: { Card }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/ReccomendationsRow/HealthCard.vue